import { Box } from '@chakra-ui/react';
import { Pressable, VStack, Text } from 'components/ui';
import { FORM_ACTIONS } from '../../../utils/formActions.js';
import { cacheFormDataInLocalStorage } from '../../../utils/formReducer.js';
import { Pill } from '../Pill';

export const ETHNICITIES = [
  'White',
  'Black or African American',
  'Hispanic or Latino',
  'American Indian or Alaska Native',
  'Asian',
  'Native Hawaiian or Other Pacific Islander',
  'Prefer not to say',
];

export const Ethnicity = ({ dispatch, formData }) => {
  const updateRace = (data: string) => {
    const cacheData = JSON.stringify({ ...formData, race: data });
    cacheFormDataInLocalStorage(cacheData);
    dispatch({
      type: FORM_ACTIONS.UPDATE_FORM_FIELD,
      fieldName: `race`,
      payload: data,
    });
  };

  return (
    <VStack data-testid="onboarding-identity" gap={6} alignItems={'flex-start'}>
      <Text textStyle="label.section" textAlign="left">
        Ethnicity
      </Text>

      <Box display="flex" flexDirection="row" flexWrap="wrap" gap="9px">
        {ETHNICITIES.map((option) => (
          <Pressable
            key={option}
            onClick={() => updateRace(option)}
            data-testid={'onboarding-identity-item'}
          >
            <Pill isSelected={formData.race === option} text={option} />
          </Pressable>
        ))}
      </Box>
    </VStack>
  );
};
